import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import store from '../../store';

import api from '../../services/MainAPI';

import Header from '../components/UI_Components/Header';
import LateralNavigation from '../components/UI_Components/LateralNavigation';
import ListUserTravels from './components/ListUserTravels';

let checkLogin = false;

export default function ListTravels() {
  const navigate = useNavigate();

  const [primaryAuth, setPrimaryAuth] = useState([]);

  async function checkLoginFunction() {
    if (!checkLogin) {
      const userToken = localStorage.getItem('@alliancesystem/token');
      const res = await api.get('/auth/primaryauth', {}, { headers: { Authorization: userToken } });
      if (res.data.error) {
        navigate('/alliancesystem/login');
      } else {
        setPrimaryAuth(res.data);
        checkLogin = true;
      }
    }
  }

  checkLoginFunction();
  return (
    <Provider store={store}>
      <Helmet>
        <title>Listar Viagens - AllianceSystem</title>
      </Helmet>
      <Header primaryAuthData={primaryAuth} sectorColor="blueHeader" />
      <LateralNavigation primaryAuthData={primaryAuth} navigationSector="TRAVELS" defaultTab={{ value: true, name: 'Voltar às Viagens', url: '/travels' }} />
      <ListUserTravels />
    </Provider>
  );
}
